export enum Action {
  PUB = 1,
  SUB = 2,
  UNSUB = 3,
}
